const URL = {
  SHOP_WEBHOOKS: 'shop-webhooks',
  SHOP_WEBHOOK_BY_ID: 'shop-webhooks/{id}',
}

export default URL
